module.exports = __webpack_public_path__ + "img/ic_home_profile@2x.cf04a33.png";